import type { App as Application } from 'vue'
import { useUser } from 'src/store/modules/App/user'
export default {
  install: function (app: Application): void {
    app.config.globalProperties.$isSameUser = function (id: string): boolean {
      const userStore = useUser()
      if (!userStore.user.id) {
        return false
      }

      return userStore.user.id === Number(id)
    }
  },
}
